import { useState } from 'react';
import Tabela from '../../Misc/Tabela/Tabela';
import { Button, Dropdown, Form } from 'react-bootstrap';
import { usePAChecklist } from './pa_checklist_context';
import styles from './pa_checklist.module.scss'
import PARevisaoDirecionamento from './components/pa_checklist_modal_direcionamento';
import PAChecklistModalCaixa from './components/pa_checklist_modal_caixa';
import PAChecklistMedidas from './components/pa_checklist_modal_medidas';
import PAChecklistAnalise from './components/pa_checklist_modal_analise';
import PARevisaoModalProcessamento from './components/pa_checklist_modal_processamento';
import FiltroChecklist from './components/pa_checklist_filtro';
import PAChecklistInformacoes from './components/pa_checklist_modal_informacoes';
import PAChecklistSubModalCaixa from './components/pa_checklist_submodal_caixa';
import PAChecklistModalCancelamento from './components/pa_checklist_modal_cancelar_analise';
import PAChecklistModalProvaDeRoupa from './components/pa_checklist_modal_prova_de_roupa';
import { toBrDateWithTime } from '../../../utils/dateUtils';
import WarningTriangle from '../ChecklistFollowUp/components/priorizacao/warning_triangle';
import PAChecklistModalLocalizacao from './components/pa_checklist_modal_localizacao';
import { useMisc } from '../../../contexts/MiscContext';
import { api } from '../../../services/api';
import { toast } from 'react-toastify';
import SelectInput from '../../Misc/SelectInput/SelectInput';

const PAChecklistMain = () => {
  const { interfaceAtiva, setInterfaceAtiva, modalCaixa, subModalCaixa, modalMedidas, modalAnalise, modalProvaDeRoupa, showModalInformacoes, listaChecklistAnaliseFiltrada, iniciarChecklistAnalise, iniciarChecklistProvaDeRoupa, modalDirecionamento, modalProcessamento, fetchChecklistGrid, listaChecklistCaixaFiltrada, modalCancelamento, iniciarChecklistCaixa, showLoadingCaixa, showLoadingAnalise, showLoadingProvaDeRoupa, listaChecklistProvaDeRoupaFiltrada, filterObjAnalise, setFilterObjAnalise, filterObjProvaDeRoupa, setFilterObjProvaDeRoupa } = usePAChecklist();
  const { setShowLoading } = useMisc();
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);
  const [produtoLoc, setProdutoLoc] = useState('');
  const [corProdutoLoc, setCorProdutoLoc] = useState('');
  const [dadosLocalizacao, setDadosLocalizacao] = useState([]);

  const abrirModalLocalizacoes = async (produto, cor_produto) => {
    try {
      setShowLoading(true);
      const res = await api.get('/pa-checklist/checklist-localizacao', { params: { produto, cor_produto } });
      setProdutoLoc(produto);
      setCorProdutoLoc(cor_produto);
      setDadosLocalizacao([...res.data]);
      setShowModalLocalizacao(true);
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar os dados de localização. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const fecharModalLocalizacoes = () => {
    setProdutoLoc('');
    setCorProdutoLoc('');
    setDadosLocalizacao([]);
    setShowModalLocalizacao(false);
  }

  const activeGrid = () => {
    if (interfaceAtiva === 101) return listaChecklistCaixaFiltrada;
    if (interfaceAtiva === 102) return listaChecklistAnaliseFiltrada;
    if (interfaceAtiva === 103) return listaChecklistProvaDeRoupaFiltrada;
  }

  const activeColumns = () => {
    if (interfaceAtiva === 101) return checklistCaixaColumns;
    if (interfaceAtiva === 102) return checklistAnaliseColumns;
    if (interfaceAtiva === 103) return checklistAnaliseColumns;
  }

  const checklistCaixaColumns = [
    {
      name: '', selector: row => {
        return (
          <Button
            onClick={() => iniciarChecklistCaixa(row)}
            style={{ fontWeight: '500' }}
            disabled={row.qtde_recebida === 0}
          >
            Produções
          </Button>
        )
      }
    },
    { name: 'Romaneio NF Saída', selector: row => row.romaneio_nf_saida },
    { name: 'Romaneio Entrada', selector: row => row.romaneio_entrada },
    {
      name: 'Entrada Conferida?', selector: row => {
        return row.entrada_conferida ?
          <div className={styles.loc_label_true}>Sim</div> :
          <div className={styles.loc_label_false}>Não</div>
      }, width: '160px'
    },
    { name: 'Qtde. Recebida', selector: row => row.qtde_recebida },
    { name: 'Filial Origem', selector: row => row.filial_origem },
    { name: 'Filial Destino', selector: row => row.filial_destino },
    { name: 'Resp. Origem', selector: row => row.responsavel_origem },
    { name: 'Resp. Conferência', selector: row => row.responsavel_conferencia },
    { name: 'Data Emissão', selector: row => toBrDateWithTime(row.data_emissao_romaneio) },
    { name: 'Data Conferência', selector: row => toBrDateWithTime(row.data_entrada_conferida) },
  ];

  const checklistAnaliseColumns = [
    interfaceAtiva !== 101 && {
      cell: row => {
        return (
          <WarningTriangle
            color={
              (
                interfaceAtiva === 102 && row.em_andamento_analise ||
                interfaceAtiva === 103 && row.em_andamento_prova_de_roupa
              ) ? '01D10C'
                : row.cor_prioridade
            }
            prioridade={row.prioridade}
            btn={
              <Button
                style={{ fontWeight: '500' }}
                variant={row.nf_segunda_qualidade || row.produto_de_couro ? 'warning' : 'primary'}
                onClick={() => {
                  if (interfaceAtiva === 102) iniciarChecklistAnalise(row);
                  if (interfaceAtiva === 103) iniciarChecklistProvaDeRoupa(row);
                }}
                disabled={
                  !interfaceAtiva || (
                    interfaceAtiva === 102 && row.em_andamento_analise ||
                    // interfaceAtiva === 102 && row.index_producao > 10 ||
                    interfaceAtiva === 103 && (row.em_andamento_prova_de_roupa || !row.analise_ok)
                  )
                }
              >
                {
                  (interfaceAtiva === 102 && 'Análise') ||
                  (interfaceAtiva === 103 && 'Prova')
                }
              </Button>
            }
          />
        )
      }, width: '160px'
    },
    {
      selector: row => {
        return (
          <Button
            style={{ fontWeight: '500' }}
            variant={'primary'}
            onClick={() => abrirModalLocalizacoes(row.produto, row.cor_produto)}
          >
            Localização
          </Button>
        )
      }, width: '140px'
    },
    {
      name: 'Revisado?', selector: row => {
        return row.revisao_ok ?
          <div className={styles.loc_label_true}>Sim</div> :
          <div className={styles.loc_label_false}>Não</div>
      }, width: '160px'
    },
    // { name: 'ID', selector: row => row.id_entrada_fiscal },
    { name: 'NF Entrada', selector: row => row.nf_entrada },
    { name: 'Serie NF', selector: row => row.serie_nf },
    { name: 'Origem', selector: row => row.origem },
    { name: 'Produto', selector: row => row.produto },
    { name: 'Desc. Produto', selector: row => row.descricao_produto },
    { name: 'Cor', selector: row => row.cor_produto },
    { name: 'Desc. Cor', selector: row => row.descricao_cor },
    { name: 'Qtde.', selector: row => row.qtde_entrada },
    { name: 'Ordem Produção', selector: row => row.ordem_producao },
    { name: 'Coleção', selector: row => row.colecao },
    { name: 'Linha', selector: row => row.linha },
    { name: 'Preço', selector: row => row.preco },
    { name: 'Data Entrada Revisão', selector: row => row.data_entrada_revisao_br }
  ].filter(Boolean);

  return (
    <>
      <section className={styles.flex_title}>
        <h4 className={styles.title}>
          Checklist PA - {
            interfaceAtiva === 101 ? 'Romaneio' :
              interfaceAtiva === 102 ? 'Análise' : 'Prova de Roupa'
          }
        </h4>

        <div className={styles.flex_section} style={{ marginLeft: 'auto' }}>
          <Dropdown>
            <Dropdown.Toggle
              variant="success"
              id="dropdown-basic"
              style={{ backgroundColor: '#527ac5', fontWeight: '500', borderColor: '#527ac590' }}
            >
              Opções
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                style={{ backgroundColor: interfaceAtiva === 101 ? '#527ac590' : 'initial', fontWeight: '500' }}
                onClick={() => setInterfaceAtiva(101)}
              >
                Romaneio
              </Dropdown.Item>
              <Dropdown.Item
                style={{ backgroundColor: interfaceAtiva === 102 ? '#527ac590' : 'initial', fontWeight: '500' }}
                onClick={() => setInterfaceAtiva(102)}
              >
                Análise
              </Dropdown.Item>
              <Dropdown.Item
                style={{ backgroundColor: interfaceAtiva === 103 ? '#527ac590' : 'initial', fontWeight: '500' }}
                onClick={() => setInterfaceAtiva(103)}
              >
                Prova de Roupa
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </section>
      <section className={styles.header_section}>
        <div className={styles.adm_btn_wrapper}>
          <FiltroChecklist />
          {
            (interfaceAtiva === 102) &&
            <div>
              <Form.Label className={styles.form_label} style={{ color: '#000000AE' }}>
                Somente Revisado?
              </Form.Label>
              <Form.Check
                type={'switch'}
                defaultChecked={false}
                style={{ fontSize: '20px' }}
                onChange={() => {
                  setFilterObjAnalise({
                    ...filterObjAnalise,
                    revisao_ok: !filterObjAnalise.revisao_ok
                  });
                }}
                value={filterObjAnalise.revisao_ok || false}
              />
            </div>
          }
          {
            (interfaceAtiva === 103) &&
            <div>
              <Form.Label className={styles.form_label} style={{ color: '#000000AE' }}>
                Somente Revisado?
              </Form.Label>
              <Form.Check
                type={'switch'}
                defaultChecked={false}
                style={{ fontSize: '20px' }}
                onChange={() => {
                  setFilterObjProvaDeRoupa({
                    ...filterObjProvaDeRoupa,
                    revisao_ok: !filterObjProvaDeRoupa.revisao_ok
                  });
                }}
                value={filterObjProvaDeRoupa.revisao_ok || false}
              />
            </div>
          }

          {
            interfaceAtiva === 101 &&
            <Button
              style={{ alignSelf: 'flex-end', fontWeight: '500' }}
              variant={'secondary'}
              onClick={async () => await fetchChecklistGrid(101)}
            >
              Atualizar Grid Romaneios
            </Button>
          }
          {
            [102, 103].includes(interfaceAtiva) &&
            <Button
              style={{ alignSelf: 'flex-end', fontWeight: '500' }}
              variant={'secondary'}
              onClick={() => fetchChecklistGrid(interfaceAtiva)}
            >
              Atualizar Tabela
            </Button>
          }
        </div>
      </section>
      <section style={{ margin: '0px 20px 20px' }}>
        <Tabela
          columns={activeColumns()}
          data={activeGrid()}
          paginationPerPage={20}
          highlightOnHover={true}
          pending={
            (interfaceAtiva === 101 && showLoadingCaixa) ||
            (interfaceAtiva === 102 && showLoadingAnalise) ||
            (interfaceAtiva === 103 && showLoadingProvaDeRoupa)
          }
        />
      </section>

      {showModalInformacoes && <PAChecklistInformacoes />}
      {modalDirecionamento && <PARevisaoDirecionamento />}
      {modalCaixa && <PAChecklistModalCaixa />}
      {subModalCaixa && <PAChecklistSubModalCaixa />}
      {modalMedidas && <PAChecklistMedidas />}
      {modalAnalise && <PAChecklistAnalise />}
      {modalProcessamento && <PARevisaoModalProcessamento />}
      {modalProvaDeRoupa && <PAChecklistModalProvaDeRoupa />}
      {modalCancelamento && <PAChecklistModalCancelamento />}
      {
        showModalLocalizacao &&
        <PAChecklistModalLocalizacao
          produto={produtoLoc}
          cor_produto={corProdutoLoc}
          localizacoes={dadosLocalizacao}
          showModalLocalizacao={showModalLocalizacao}
          setShowModalLocalizacao={fecharModalLocalizacoes}
        />
      }
    </>
  );
}

export default PAChecklistMain;
